<div class="container">
  <h2>{{ 'contactUs.title' | cxTranslate }}</h2>
  <div class="d-flex flex-wrap justify-content-center">
    <form #frm [formGroup]="contactForm" (submit)="submitForm()" class="row w-75">
      <div class="col-md-12">
        <p class="subtitle">{{ 'contactUs.subtitle' | cxTranslate }}</p>
      </div>
      <div class="form-group col-md-10">
        <label>
          <span class="label-content mandatory">{{ 'contactUs.name' | cxTranslate }}</span>
          <input class="form-control" type="text" formControlName="fullName" />
          <cx-form-errors [control]="contactForm.get('fullName')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-6">
        <label>
          <span class="label-content mandatory">{{ 'contactUs.email' | cxTranslate }}</span>
          <input class="form-control" type="text" formControlName="email" />
          <cx-form-errors [control]="contactForm.get('email')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-6">
        <label>
          <span class="label-content mandatory">{{ 'contactUs.phone' | cxTranslate }}</span>
          <input class="form-control" type="text" formControlName="phone" />
          <cx-form-errors [control]="contactForm.get('phone')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-12">
        <label>
          <span class="label-content mandatory">{{ 'contactUs.description' | cxTranslate }}</span>
          <textarea class="form-control" placeholder="{{ 'contactUs.descriptionPlaceholder' | cxTranslate }}" formControlName="message"></textarea>
          <cx-form-errors [control]="contactForm.get('message')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-12">
        <app-custom-file-uploader [label]="'forms.contactUs.fileAddImage' | cxTranslate" [formGroup]="contactForm" [required]="false" [maxFileSize]="5120">
        </app-custom-file-uploader>
      </div>
      <div class="col-md-12">
        <p class="info-text info-text-bottom">
          <span [innerHTML]="'forms.contactUs.basicInfoPrivacy' | cxTranslate"></span>
          <a class="link-terms" [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">{{ 'contactUs.privacyTerms' | cxTranslate }}</a>
        </p>
      </div>
      <div class="form-group col-md-5">
        <div class="form-check keep-in-session">
          <label class="checkbox">
            <input type="checkbox" formControlName="privacyPolicy" />
            <span class="form-check-label info-text mandatory">
              <span [innerHTML]="'forms.contactUs.termsAndConditions' | cxTranslate"></span>
              <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
                {{ 'contactUs.termsAndConditions2' | cxTranslate }}
              </a>
            </span>
          </label>
        </div>
        <cx-form-errors [control]="contactForm.get('privacyPolicy')"></cx-form-errors>
      </div>
      <div class="row col-md-12 m-0 btn-margin">
        <button class="btn btn-block btn-black col-md-5" type="submit" [disabled]="submitted$ | async">
          {{ 'contactUs.send' | cxTranslate }}
        </button>
      </div>
    </form>
  </div>
</div>
